import React from "react";
import { ArrowRight } from "lucide-react";
import { APP_URL } from "../lib/constants";

export const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative py-16 sm:py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="relative gradient-border rounded-3xl overflow-hidden p-[1px]">
          <div
            className="relative bg-[#050505] rounded-3xl px-6 py-12 sm:px-8 sm:py-16 lg:py-24 lg:px-16 overflow-hidden"
            style={{
              backgroundImage:
                "radial-gradient(ellipse at top right, rgba(0,229,255,0.12), transparent 50%), radial-gradient(ellipse at bottom left, rgba(57,255,20,0.10), transparent 55%)",
            }}
          >
            <div className="relative max-w-3xl">
              <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-400 mb-5">
                [ Begin · 7-day free trial ]
              </div>
              <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-semibold leading-[0.95] text-white">
                The next time your battery degrades, you'll{" "}
                <span className="brand-text-gradient">know first.</span>
              </h2>
              <p className="text-zinc-400 mt-6 sm:mt-7 text-base sm:text-lg max-w-xl leading-relaxed">
                Connect your Tesla in 30 seconds.
                Cancel from your account anytime.
              </p>
              <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-3">
                <a
                  href={APP_URL}
                  data-testid="final-cta-button"
                  className="brand-gradient text-black font-semibold rounded-full px-6 sm:px-8 py-3.5 sm:py-4 inline-flex items-center gap-2 hover:opacity-90 transition-opacity glow-green text-sm sm:text-base"
                >
                  Connect Tesla account
                  <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
                </a>
                <a
                  href={APP_URL}
                  data-testid="final-cta-secondary"
                  className="text-zinc-300 hover:text-white text-sm font-medium px-4 py-4 transition-colors"
                >
                  Or open the app →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
